import React, { useMemo } from 'react';
import { useRouter } from '@funtech-int/rival-react';

import { mainRoute } from '@/scenarios/home';
import { useLocale } from '@/shared/hooks/useLocale';
import { useClientSupport } from '@/shared/hooks/useClientSupport';
import { clientConfig } from '@/config/client';
import { getSubscriptionUrl } from '@/shared/lib/getSubscriptionUrl';

import { HomeFaqItems } from '../types';

import { useI18n } from './useFaqI18n';

const { brandName } = clientConfig;

const allplayLink = (chunks: any, mainLink: string) => <a href={mainLink}>{chunks}</a>;
const personalLink = (chunks: any, lang: string) => <a href={getSubscriptionUrl(lang)}>{chunks}</a>;
const supportLink = (chunks: any, supportLink: string) => <a href={supportLink}>{chunks}</a>;

export const useBaseQuestions = (): HomeFaqItems => {
    const i18n = useI18n();
    const router = useRouter();
    const { lang } = useLocale();
    const { clientSupportLink } = useClientSupport();

    const mainLink = router.serialize(mainRoute());

    return useMemo(
        () => [
            {
                title: i18n('faq__what_is_title', { brandName }),
                answer: i18n('faq__what_is_answer', { brandName }),
            },
            {
                title: i18n('faq__how_connect_title', { brandName }),
                answer: i18n('faq__how_connect_answer', {
                    br: <br />,
                    brandName,
                    bold: (chunks: any) => <b>{chunks}</b>,
                    allplayLink: (chunks: any) => allplayLink(chunks, mainLink),
                }),
            },
            {
                title: i18n('faq__subscription_includes_title', { brandName }),
                answer: i18n('faq__subscription_includes_answer', {
                    brandName,
                    ul: (chunks: any) => <ul>{chunks}</ul>,
                    li: (chunks: any) => <li>{chunks}</li>,
                    br: <br />,
                }),
            },
            {
                title: i18n('faq__about_plus_title', { brandName }),
                answer: i18n('faq__about_plus_answer', {
                    brandName,
                    personalLink: (chunks: any) => personalLink(chunks, lang),
                }),
            },
            {
                title: i18n('faq__does_not_work_title', { brandName }),
                answer: i18n('faq__does_not_work_answer', {
                    brandName,
                    supportLink: (chunks: any) => supportLink(chunks, clientSupportLink),
                }),
            },
            {
                title: i18n('faq__how_unsubscribe_title', { brandName }),
                answer: i18n('faq__how_unsubscribe_answer', {
                    br: <br />,
                    bold: (chunks: any) => <b>{chunks}</b>,
                    personalLink: (chunks: any) => personalLink(chunks, lang),
                }),
            },
            {
                title: i18n('faq__how_manage_title', { brandName }),
                answer: i18n('faq__how_manage_answer', {
                    personalLink: (chunks: any) => personalLink(chunks, lang),
                }),
            },
            {
                title: i18n('faq__available_title', { brandName }),
                answer: i18n('faq__available_answer'),
            },
            {
                title: i18n('faq__devices_title', { brandName }),
                answer: i18n('faq__devices_answer', {
                    brandName,
                    allplayLink: (chunks: any) => allplayLink(chunks, mainLink),
                }),
            },
        ],
        [clientSupportLink, i18n, lang, mainLink]
    );
};
